import { render, staticRenderFns } from "./WorkAndShop.vue?vue&type=template&id=3a871190&"
import script from "./WorkAndShop.vue?vue&type=script&lang=js&"
export * from "./WorkAndShop.vue?vue&type=script&lang=js&"
import style0 from "./WorkAndShop.vue?vue&type=style&index=0&id=3a871190&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports